import { useState, createContext, useContext } from "react";

// Create context for vessel owner form data
const VesselOwnerFormContext = createContext();

// Provider component to manage form state
export const VesselOwnerFormProvider = ({ children }) => {
  const [formDatas, setFormDatas] = useState({
    companyName: "",
    registrationNumber: "",
    phoneNumber: "",
    phoneCountryCode: "", 
    yearsInOperation: "",
    website: "",
    linkedIn: "",
    serviceCategory: [],
    keywords: [],
    address: "",
    state: "",
    city: "",
    country: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDatas(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSelectionChange = (name, value) => {
    if (!value) return;
    setFormDatas(prev => ({
      ...prev,
      [name]: prev[name].includes(value) ? prev[name] : [...prev[name], value]
    }));
  };

  const removeSelection = (name, value) => {
    setFormDatas(prev => ({
      ...prev,
      [name]: prev[name].filter(item => item !== value)
    }));
  };

  const updateFormData = (newData) => {
    setFormDatas(prev => ({
      ...prev,
      ...newData
    }));
  };

  const resetForm = () => {
    setFormDatas({
      companyName: "",
      registrationNumber: "",
      phoneNumber: "",
      phoneCountryCode: "", 
      yearsInOperation: "",
      website: "",
      linkedIn: "",
      serviceCategory: [],
      keywords: [],
      address: "",
      state: "",
      city: "",
      country: ""
    });
  };

  return (
    <VesselOwnerFormContext.Provider value={{
      formDatas,
      handleInputChange,
      handleSelectionChange,
      removeSelection,
      updateFormData,
      resetForm
    }}>
      {children}
    </VesselOwnerFormContext.Provider>
  );
};

// Hook to use the form context
const useVesselOwnerForm = () => {
  const context = useContext(VesselOwnerFormContext);
  if (!context) {
    throw new Error('useVesselOwnerForm must be used within a VesselOwnerFormProvider');
  }
  return context;
};

export default useVesselOwnerForm;